import { useState, forwardRef, useEffect, useRef } from "react";
import { NavLink, useParams} from 'react-router-dom';
import { useForm, Controller, useFieldArray  } from 'react-hook-form';
import AddressGenerator from '../Caracterizacion/Personas/AdressGenerator';
import SweetAlert2 from 'react-sweetalert2';
import apiService from '../../Auth/apiService';
import { useAuth } from '../../Auth/AuthContext';
import DataTable from 'react-data-table-component';
import { Tooltip } from 'react-tooltip';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { registerLocale, setDefaultLocale } from 'react-datepicker';
import { es } from 'date-fns/locale';
import Select from 'react-select';
import SumOneDayDate from "../Utils/SumOneDayDate";
import MenuCaracterizacion from "../Caracterizacion/Componentes/MenuCaracterizacion";
import { FaArrowAltCircleRight, FaCalendar, FaEraser, FaFile, FaHeartbeat, FaMap } from "react-icons/fa";
import { BotonBorrar } from "../Utils/BotonBorrar";
import SeccionPageHeader from "../Utils/SeccionPageHeader";
import CargandoSpinner from "../Utils/CargandoSpinner";
import VerRetornos from "./VerRetornos";

registerLocale('es', es);
setDefaultLocale('es');

export default function Retorno(){
    const { token, rol, user } = useAuth();
    const [Cargando, setCargando] = useState(false);
    const { idCabezaFamilia } = useParams();
    const [showDireccionPrincipal, setshowDireccionPrincipal] = useState(false);
    const [showDireccionPeticion, setShowDireccionPeticion] = useState(false);
    const [showDireccionRed, setShowDireccionRed] = useState(false);
    const [showListaRetornos, setShowListaRetornos] = useState(false);
    const [swalProps, setSwalProps] = useState({});
    const showModalDireccionPrincipal = () => setshowDireccionPrincipal(true);
    const hideModalDireccionPrincipal = () => setshowDireccionPrincipal(false);
    const showModalDireccionPeticion = () => setShowDireccionPeticion(true);
    const hideModalDireccionPeticion = () => setShowDireccionPeticion(false);
    const showModalDireccionRed = () => setShowDireccionRed(true);
    const hideModalDireccionRed = () => setShowDireccionRed(false);
    const verRetornosRef = useRef();
    const { control, handleSubmit, register, setValue, getValues, watch, reset, formState: { errors }} = useForm({
        defaultValues: {
            MotivosRetorno: [],
            tiposVoluntariedadSeleccionados: [],
            tiposEspeciesSeleccionados: [],
            tiposExplotacionSeleccionados: [],
            quienesPsicosocial: [],
            personasGrupoFamiliar: [],
        }
    });
    const [showCorregimientoRetorno, setShowCorregimientoRetorno] = useState(false);
    const viviendaIntegrante = watch('viviendaIntegrante');
    const documentacionVivienda = watch('documentacionVivienda');
    const miembrosAtencionPsicosocial = watch('miembrosAtencionPsicosocial');
    const convocatoriaVivienda = watch('convocatoriaVivienda');
    const redesPlanVida = watch('redesPlanVida');
    const [CabezaFamiliaDatos, setCabezaFamiliaDatos] = useState({
        nombre: '',
        cab_idcabezafamilia: '',
        cab_direccion: '',
        telefono: '',
        cab_celular: '',
        cab_correoelectronico: '',
        cab_nodeclaracion: ''
      });
    const [ultimodesplazamiento, setUltimoDesplazamiento] = useState({
        regIdcabezafamilia: "",
        regTipomovilidadid: "",
        regNumdesplazamientoid: "",
        regDenuncio: "",
        regTipodesplazamientoid: "",
        regFechacreacion: "",
        regFecharadicacion: "",
        regDepartamento: "0",
        regMunicipio: "0",
        id: "0",
        regLugar: "0",
        regTipolugar: "8",
        regAnodes: null,
        regDiades: null,
        regMesdes: null,
        regFechadesplazamiento: null
    });
    const [registroDesplazamientoDTO, setRegistroDesplazamientoDTO] = useState({
        numpersonas: "0",
        tiempociudad: 0
    });
    const [personasGrupoFamiliar, setPersonasGrupoFamiliar] = useState([]);
    const [retornoId, setRetornoId] = useState(0);
    const [retornosactivo, setRetornosactivo] = useState([]);
    const [tiposPropietario, setTiposPropietario] = useState([]);
    const [tiposobjeto, setTiposobjeto] = useState([]);
    const [barrios, setBarrios] = useState([]);
    const [barriosPeticion, setBarriosPeticion] = useState([]);
    const [retornoTipoBien, setRetornoTipoBien] = useState([]);
    const [ordenSalud, setOrdenSalud] = useState([]);
    const [estadosBien, setRetornoEstadosBien] = useState([]);
    const [tiposred, setTiposred] = useState([]);
    const [tiposConvocatoria, setTiposConvocatoria] = useState([]);
    const [municipiosdto, setMunicipiosdto] = useState([]);
    const [municipios, setMunicipios] = useState([]);
    const [departamentos, setDepartamentos] = useState([]);
    const [tiposmotivo, setTiposmotivo] = useState([]);
    const [tiposvoluntariedad, setTiposvoluntariedad] = useState([]);
    const [tiposapoyo, setTiposapoyo] = useState([]);
    const [tiposEspecies, setTiposEspecies] = useState([]);
    const [conceptosSeguridad, setConceptosSeguridad] = useState([]);
    const [Personas, setPersonas] = useState([]);
    const [quienesPsicosocial, setQuienesPsicosocial] = useState([]);
    const [tiposentorno, setTiposentorno] = useState([]);
    const [tiposEspeciesSeleccionados, setTiposEspeciesSeleccionados] = useState([]);
    const [tiposExplotacion, setTiposExplotacion] = useState([]);
    const [tiposExplotacionSeleccionados, setTiposExplotacionSeleccionados] = useState([]);
    const [motivosSeleccionados, setMotivosSeleccionados] = useState([]);
    const [tiposVoluntariedadSeleccionados, setTiposVoluntariedadSeleccionados] = useState([]);
    const Mensaje = (title, text) => {
        setSwalProps({
            show: true,
            title: title,
            text: text,
        });
    };
    function mensajeEliminar(title, text) {
        return new Promise((resolve) => {
            setSwalProps({
            show: true,
            title: title,
            text: text,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Sí, eliminar',
            cancelButtonText: 'Cancelar',
            preConfirm: () => resolve(true),
            didClose: () => resolve(false),
            });
        });
    }
    async function ConsultarMunicipios(Departamento) {
        const municipios = municipiosdto
            .filter(municipio => municipio.mun_departamentoid === String(Departamento))
            .map(municipio => ({
                id: String(municipio.id),
                munMunicipio: String(municipio.mun_municipio),
                munDepartamentoid: String(municipio.mun_departamentoid),
                munActivo: municipio.mun_activo
            }));
        setMunicipios(municipios);
    }
    async function SeleccionarRetorno (row){
        const url = '/retorno/consultarretorno';
        const obj = { idRetorno: row.id }
        setCargando(true);
        await apiService.post(url, obj, token)
        .then(response => {
            const result = response.data;
            ResetFormRetorno (result.retorno[0], result.retornoRedes.map(red => ({
                redTipo: red.retTipo,
                redParentesco: red.retParentesco,
                redNombre: red.retNombrecompleto,
                redTelefonos: red.retTelefonos,
                redDireccion: red.retDireccion,
                redMunicipio: red.retMunicipio,
                municipio: municipiosdto.find(x => x.id === red.retMunicipio)?.mun_municipio || '',
            })),result.retornoObjeto, result.personaSalud);
            const motivosSelected = tiposmotivo.filter(option => 
                result.retornoMotivo.some(motivo => String(motivo.retTipomotivoid) === option.value)
            );
            setMotivosSeleccionados(motivosSelected);
            const voluntariedad = tiposvoluntariedad.filter(option =>
                result.retornovoluntariedad.some(voluntad => String(voluntad.retTipovoluntariedadid) === option.value)
            );
            setTiposVoluntariedadSeleccionados(voluntariedad);
            const especie = tiposEspecies.filter(option =>
                result.retornoEspecie.some(especie => especie.retTipoEspecieId === option.value)
            );
            setTiposEspeciesSeleccionados(especie);
            const explotacion = tiposExplotacion.filter(option =>
                result.retornoExplotacion.some(explotacion => String(explotacion.retTipoexplotacionid) === option.value)
            );
            setTiposExplotacionSeleccionados(explotacion);
            const psicosocial = Personas.filter(option =>
                result.retornoNucleoPsicosocial.some(psicosocial => String(psicosocial.retIdpersona) === option.value)
            );
            setQuienesPsicosocial(psicosocial);
            const updatedPersonas = personasGrupoFamiliar.map(persona => 
                result.retornoNucleo.some(nucleo => nucleo.retIdpersona === persona.per_idpersona) 
                    ? { ...persona, seleccion: true } 
                    : persona
            );
            setPersonasGrupoFamiliar(updatedPersonas);
           setRetornoId(result.retorno[0].id);
        })
        .catch(error => {
            Mensaje('Consultar retorno', `Hubo un error con la carga de datos con el documento ${row.id}`, error);
        })
        .finally(() => {
            setCargando(false);
        });
    };
    function ResetFormRetorno (data, redsocial, retornosobjeto, personasalud){
        const fecha = new Date();
        fecha.setHours(fecha.getHours() - 5);
        if (!ultimodesplazamiento || Object.keys(ultimodesplazamiento).length === 0) {
            Mensaje('Datos incompletos', 'No se encontraron datos del último desplazamiento.');
            return;
        }
        
        reset((prevValues) => {
            const updatedValues = {
            ...prevValues,
            id: data?.id || '0',
            usrId: user,
            cabIdcabezafamilia: data?.retIdcabezafamilia || CabezaFamiliaDatos.cab_idcabezafamilia,
            cab_direccion: CabezaFamiliaDatos.cab_direccion,
            cab_barrio: CabezaFamiliaDatos.cab_barrio,
            cab_telefono1: CabezaFamiliaDatos.cab_telefono1,
            cab_telefono2: CabezaFamiliaDatos.cab_telefono2,
            cab_celular: data?.retCelulares || CabezaFamiliaDatos.cab_celular,
            fechaEntrevista: (data?.retFechaentrevista ? SumOneDayDate(new Date(data?.retFechaentrevista)) : fecha),
            fechaVisitaDomiciliaria: (data?.retFechavisitadomiciliaria ? SumOneDayDate(new Date(data?.retFechavisitadomiciliaria)) : fecha),
            valoracionSituacionInicial: data?.retValoracionsituacioninicial || '',
            municipioDesplazamiento: ultimodesplazamiento?.regMunicipio || '',
            fechaDesplazamiento: (ultimodesplazamiento?.regFechadesplazamiento ? SumOneDayDate(new Date(ultimodesplazamiento.regFechadesplazamiento)) : ''),
            nropersonas: registroDesplazamientoDTO.numpersonas,
            tiempociudad: registroDesplazamientoDTO.tiempociudad,
            tipoApoyoId: data?.retTipopeticion || '',
            departamentoPeticion: data?.retDepartamentopeticion || '',
            direccionPeticion: data?.retDireccionpeticion || '',
            municipioPeticion: String(data?.retMunicipiopeticion || ''),
            telefonoPeticion: data?.retTelefonopeticion || '',
            corregimientoPeticion: data?.retCorregimientopeticion || '',
            tipoentornoPeticion: data?.retTipoentornopeticion || '',
            veredabarrioPeticion: data?.retVeredabarriopeticion || '',
            nombrefincaPeticion: data?.retNombrefincapeticion || '',
            referenciasPeticion: data?.retReferenciaspeticion || '',
            viviendaIntegrante: data?.retViviendaintegrante || '',
            propietarioViviendaNucleo: data?.retPropietarioviviendanucleo || '',
            propietarioVivienda: String(data?.retPropietariovivienda || ''),
            documentacionVivienda: data?.retDocumentacionvivienda || '',
            protegioBien: data?.retProtegiobien || '',
            tipoBien: data?.retTipobien || '',
            resolucionProteccion: data?.retResolucionproteccion || '',
            estadoTecho: data?.retEstadotecho || '',
            estadoPisos: data?.retEstadopisos || '',
            estadoBanos: data?.retEstadobanos || '',
            estadoParedes: data?.retEstadoparedes || '',
            estadoCocina: data?.retEstadococina || '',
            servicioAlcantarillado: data?.retServicioalcantarillado || '',
            servicioPozoSeptico: data?.retServiciopozoseptico || '',
            servicioAcueducto: data?.retServicioacueducto || '',
            servicioEnergia: data?.retServicioenergia || '',
            otraFuenteAgua: data?.retOtrafuenteagua || '',
            salud: personasalud?.[0]?.perSalud || '',
            educacion: data?.retEducacion || '',
            miembrosAtencionPsicosocial: data?.retMiembrosatencionpsicosocial || '',
            convocatoriaVivienda: data?.retConvocatoriasvivienda || '',
            convocatoriaCual: data?.retConvocatoriacual || '',
            RedSocialSeleccionado: redsocial || [],
            redDescripcionValoracion: data?.retDescripcionvaloracionred || '',
            estadoActualSeguridad: data?.retEstadoactualseguridad || '',
            observacionesFinales: data?.retObservacionesfinales || '',
            redesFecha: data?.retRedesfecha || fecha,
            redesNombreContacto: data?.retRedesnombrecontacto || '',
            redesResultado: data?.retRedesresultado || '',
            redesVoluntariedad: data?.retRedesvoluntariedad || '',
            redesConceptoSeguridad: data?.retRedesconceptoseguridad || '',
            redesEntidadConcepto: data?.retRedesentidadconcepto || '',
            redesPlanVida: data?.retRedesplanvida || '',
            redesDescripcionPlanVida: data?.retRedesdescripcionplanvida || '',
            areaHuerta: String(data?.retAreahuerta || ''),
            redesDescripcionInsumos: data?.retRedesdescripcioninsumos || '',
            redesTransportePersonasNro: data?.retRedestransportepersonasnro || '',
            redesTransportePersonasCosto: data?.retRedestransportepersonascosto || '',
            redesAcarreoCosto: data?.retRedesacarreocosto || '',
            retornoobjeto: tiposobjeto.reduce((acc, objeto) => {
                acc[objeto.id] = String(retornosobjeto?.find(item => String(item.retTipoobjetoid) === objeto.id)?.retCantidad || ''); 
                return acc;
            }, {}),
            };
            
            if (updatedValues.departamentoPeticion) {
                ConsultarMunicipios(updatedValues.departamentoPeticion).then(() => {
                    if (updatedValues.municipioPeticion) {
                        setValue('municipioPeticion', updatedValues.municipioPeticion);
                    }
                });
            }
            return updatedValues;
        });
    }
    function setDireccionPrincipal(data){
        setValue('cab_direccion', data);
    }
    function setDireccionPeticion(data){
        setValue('direccionPeticion', data);
    }
    function setDireccionRed(data){
        setValue('redDireccion', data);
    }
    const { RedSocialSeleccionado, append, remove } = useFieldArray({
        control,
        name: 'RedSocialSeleccionado'
      });
    function BorrarRedSocial (row){
        remove(getValues('RedSocialSeleccionado').indexOf(row));
    };
    const AgregarRedSocial = async () => {
        const municipio = municipiosdto.find(x => x.id === getValues('redMunicipio')).mun_municipio;
        append({
            redTipo: getValues('redTipo'), 
            redParentesco: getValues('redParentesco'), 
            redNombre : getValues('redNombre'),
            redTelefonos: getValues('redTelefonos'),
            redDireccion: getValues('redDireccion'), 
            redMunicipio: getValues('redMunicipio'),
            municipio: municipio
        });
        setValue('redTipo', '');
        setValue('redParentesco', '');
        setValue('redNombre', '');
        setValue('redTelefonos', '');
        setValue('redDireccion', '');
        setValue('redMunicipio', '');
    };
    const refreshVerRetornos = () => {
        if (verRetornosRef.current) {
            verRetornosRef.current.refresh(); // Invoke the refresh method in VerRetornos
        }
    };
    const fetchDataListaRetornos = async (idCabezaFamilia, rol) => {
        const url = '/retorno/verretornos';
        const obj = {idCabezaFamilia: idCabezaFamilia, usrRolid: rol }
        try {
            setCargando(true);
            const response = await apiService.post(url, obj, token);
            const result = await response.data;
            if(result){
                return result;
            }
        } catch (error) {
            Mensaje('Atenciones', `Hubo un error con la carga de datos con el documento ${idCabezaFamilia}`, 'error');
        } finally {
            setCargando(false);
        }
    };

    useEffect(() => {
        const fetchData = async () => {
            const url = '/retorno/crearformularioinicializarretornos';
            const obj = {idCabezaFamilia: idCabezaFamilia, usrRolid: rol }
            try {
                setCargando(true);
                const response = await apiService.post(url, obj, token);
                const result = await response.data;
                setCabezaFamiliaDatos(result.cabezafamilia);
                setPersonasGrupoFamiliar(result.integrantesRetornoDTO);
                setTiposEspecies(result.tiposespecies.map(option => ({value: option.id, label: option.retTipoespecie})));
                setTiposExplotacion(result.tiposexplotacion.map(option => ({value: option.id, label: option.retTipoexplotacion})));
                setPersonas(result.integrantesRetornoDTO.map(option => ({
                    value: option.per_idpersona || '',
                    label: `${option.per_nombre1 || ''} ${option.per_nombre2 || ''} ${option.per_apellido1 || ''} ${option.per_apellido2 || ''}`.trim()
                })));
                setUltimoDesplazamiento(result.ultimodesplazamiento);
                setRegistroDesplazamientoDTO(result.registroDesplazamientoDTO);
                setRetornosactivo(result.retornosactivos);
                setBarrios(result.barrios);
                setMunicipiosdto(result.municipiosdto);
                setTiposapoyo(result.retornoTiposApoyo);
                setTiposmotivo(result.retornoTiposMotivo.map(option => ({value: option.id, label: option.tipTipomotivo})));
                setTiposvoluntariedad(result.retornoTiposVoluntariedad.map(option => ({value: option.id, label: option.tipTipovoluntariedad})));
                setDepartamentos(result.departamentos);
                setTiposentorno(result.tiposentorno);
                setRetornoTipoBien(result.tiposbien);
                setRetornoEstadosBien(result.estadosbien);
                setOrdenSalud(result.ordensalud);
                setTiposConvocatoria(result.tiposconvocatoria);
                setTiposred(result.tiposred);
                setConceptosSeguridad(result.conceptosseguridad);
                setTiposobjeto(result.tiposobjeto);
                setTiposPropietario(result.tipospropietario);
            } catch (error) {
                console.error('Error fetching data:', error);
            } finally {
                setCargando(false);
            }
        };
        fetchData();
    }, [rol, idCabezaFamilia, token]);
    async function EliminarRetorno (id){
        const confirmDelete = await mensajeEliminar("Eliminar Retorno", "¿Está seguro de que desea eliminar este retorno?");
        if (!confirmDelete) {
            return;
        }
        setCargando(true);
        const url = '/retorno/eliminarretorno';
        const obj = { idRetorno: id, usrId: user }
        await apiService.post(url, obj, token)
        .then(response => {
            if(response.status === 200){
                Mensaje('Retorno eliminado', JSON.stringify(response.data.message));
                refreshVerRetornos();
                setRetornosactivo(response.data.ListaRetornos)
                ResetFormRetorno();
                setRetornoId(0)
            }
        })
        .catch(error => {
            if(error.status === 422){
                Mensaje('Hubo problemas eliminando retorno', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Hubo problemas eliminando retorno', JSON.stringify(error.response.data));
            }else{
                Mensaje('Hubo problemas eliminando retorno', JSON.stringify(error));
            }
        })
        .finally(() => {setCargando(false);})
    }
    const guardarRetorno = async (data) => {
        setCargando(true);
        let url = '';
        if(data.id==="0"){
            if(idCabezaFamilia === "0"){
                data.cabIdcabezafamilia = data.perIdpersona;
            }
            url = '/retorno/guardarretorno';
        }else{
            url = '/retorno/actualizarretorno';
        }
        data.motivosSeleccionados = motivosSeleccionados.map(option => ({
            id: option.value
        }));
        data.tiposVoluntariedadSeleccionados = tiposVoluntariedadSeleccionados.map(option => ({
            id: option.value
        }));
        data.tiposEspeciesSeleccionados = tiposEspeciesSeleccionados.map(option => ({
            id: option.value
        }));
        data.tiposExplotacionSeleccionados = tiposExplotacionSeleccionados.map(option => ({
            id: option.value
        }));
        data.quienesPsicosocial = quienesPsicosocial.map(option => ({
            id: option.value
        }));
        data.personasGrupoFamiliar = personasGrupoFamiliar.filter(persona => persona.seleccion === true);
        data.fechaDesplazamiento = data.fechaDesplazamiento instanceof Date 
            ? data.fechaDesplazamiento.toISOString().split('T')[0] 
            : (data.fechaDesplazamiento ? new Date(data.fechaDesplazamiento).toISOString().split('T')[0] : null);
        data.fechaEntrevista = data.fechaEntrevista instanceof Date 
            ? data.fechaEntrevista.toISOString().split('T')[0] 
            : (data.fechaEntrevista ? new Date(data.fechaEntrevista).toISOString().split('T')[0] : null);
        data.fechaVisitaDomiciliaria = data.fechaVisitaDomiciliaria instanceof Date 
            ? data.fechaVisitaDomiciliaria.toISOString().split('T')[0] 
            : (data.fechaVisitaDomiciliaria ? new Date(data.fechaVisitaDomiciliaria).toISOString().split('T')[0] : null);
        data.redesFecha = data.redesFecha instanceof Date 
            ? data.redesFecha.toISOString().split('T')[0] 
            : (data.redesFecha ? new Date(data.redesFecha).toISOString().split('T')[0] : null);
        await apiService.post(url, data, token)
        .then(response => {
            if(response.status === 200){
                Mensaje('Guardar retorno', JSON.stringify(response.data.message));
                refreshVerRetornos();
                setRetornosactivo(response.data.ListaRetornos)
            }
        })
        .catch(error => {
            if(error.status === 422){
                Mensaje('Hubo problemas guardando retorno', JSON.stringify(error.response.data.errors));
            }else if(error.status === 409){
                Mensaje('Hubo problemas guardando retorno', JSON.stringify(error.response.data));
            }else{
                Mensaje('Hubo problemas guardando retorno', JSON.stringify(error));
            }
        })
        .finally(() => {setCargando(false);})
    };
    const ActualizarBarrios = async (event) => {
        setShowCorregimientoRetorno(event.target.value === '1');
        setBarriosPeticion((event.target.value === '1')?barrios:[]);    
      };
    const ActualizarQuienesPsicosocial = quien => {
        setQuienesPsicosocial(quien);
    };
    const ActualizarTiposEspecies = especies => {
        setTiposEspeciesSeleccionados(especies);
    };
    const ActualizarTiposExplotacion = tipoexplotacion => {
        setTiposExplotacionSeleccionados(tipoexplotacion);
    };
    const ActualizarMotivos = motivo => {
        setMotivosSeleccionados(motivo);
    };
    const ActualizarTiposVoluntariedad = tipo => {
        setTiposVoluntariedadSeleccionados(tipo);
    };
    const ActualizarMunicipios = async (event) => {
        await ConsultarMunicipios(event.target.value);
      };
    const CustomInput = forwardRef(({ value, onClick }, ref) => (
        <button type="button" className="custom-input" onClick={onClick} onKeyDown={onClick} ref={ref}>
            <input value={value} readOnly className='widthCalendar'/>
            <FaCalendar size={20} color="black" />
        </button>
    ));
    return (
        <div className="content-wrapper">
            <SeccionPageHeader title="Retornos" idCabezaFamilia={idCabezaFamilia} url={`/caracterizacion/grupofamiliar/${idCabezaFamilia}`} nombreurl="Grupo familiar" nombreform="Retornos" />
            <CargandoSpinner Cargando={Cargando} />
            <section className="content">
                <div className="container-fluid">
                    <MenuCaracterizacion idCabezaFamilia={idCabezaFamilia} />
                    
                    <div className="row">
                        {/* left column */}
                        <div className="col-md-12">
                            <button type="button" className="btn btn-block btn-outline-primary" onClick={ResetFormRetorno}>Nuevo retorno</button>
                        </div>
                        {/*/.col (left) */}

                    </div>
                    {/* /.row */}
                    <div className="row">
                        {retornosactivo.length === 0 && <div className="col-md-12" style={{backgroundColor: 'red', textAlign: 'center'}}>
                            <p>NO existen procesos de retorno activos para esta familia</p>
                        </div>}
                        {retornosactivo.length > 0 && <div className="col-md-12">
                            <div className="card-body table-responsive p-0">
                                <h5>Seleccione el retorno con el que desea trabajar</h5>
                                <table className="table table-bordered table-hover">
                                    <thead>
                                        <tr>
                                            <th>Acciones</th>
                                            <th>Id</th>
                                            <th>Fecha</th>
                                            <th>Municipio</th>
                                            <th>Departamento</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {retornosactivo.length === 0 ? (
                                            <tr>
                                                <td colSpan="5" className="text-center">
                                                    No hay datos para mostrar
                                                </td>
                                            </tr>
                                        ) : (
                                            retornosactivo.map((row, idx) => (
                                                <tr key={row.id || idx}>
                                                    <td>
                                                        <button
                                                            type="button"
                                                            onClick={() => SeleccionarRetorno(row)}
                                                            style={{
                                                                backgroundColor: 'red',
                                                                border: 'none',
                                                                borderRadius: '6px',
                                                                padding: '6px 12px',
                                                                color: 'white',
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                justifyContent: 'center'
                                                            }}
                                                            data-tooltip-id='tooltiparriba'
                                                            data-tooltip-content="Seleccionar"
                                                        >
                                                            <FaArrowAltCircleRight size={20} color="white" />
                                                        </button>
                                                    </td>
                                                    <td>{row.id}</td>
                                                    <td>{row.ret_fechaentrevista ? row.ret_fechaentrevista.split('T')[0] : ''}</td>
                                                    <td>{row.mun_municipio}</td>
                                                    <td>{row.dep_departamento}</td>
                                                </tr>
                                            ))
                                        )}
                                    </tbody>
                                </table>
                            </div>
                        </div>}
                    </div>
                    <div className="row">
                        <div className="col-md-12" style={{textAlign: 'center'}}>
                            <button 
                                type="button" 
                                className="btn btn-link" 
                                onClick={() => showListaRetornos?setShowListaRetornos(false):setShowListaRetornos(true)}>
                                <FaFile size={20} color="black" /> {showListaRetornos && <span>Ocultar</span>}{!showListaRetornos && <span>Ver</span>} todos los retornos
                            </button>
                        </div>
                    </div>
                </div>
                {showListaRetornos && <VerRetornos 
                    show={showListaRetornos} 
                    idCabezaFamilia={idCabezaFamilia} 
                    rol={rol} 
                    token={token}
                    Cargando={Cargando}
                    setCargando={setCargando}
                    Mensaje={Mensaje} 
                    fetchData={fetchDataListaRetornos}/>}
                <div className="container-fluid">

                    <div className="row">
                    <div className="col-md-12">
                        <div className="card card-info">
                        <div className="card-header">
                            <h3 className="card-title" >
                                COMPONENTE DE RETORNO Y REUBICACION - CARACTERIZACION FAMILIAR Y VISITA DOMICILIARIA
                            </h3>
                        </div>
                        {/* /.card-header */}
                        <div className="card-body">
                            {retornoId > 0 && <div className="row">
                                <div className="col-md-1">
                                    <NavLink to={`/retornos/crearretornos/${retornoId}/${idCabezaFamilia}`} 
                                        className="btn btn-app bg-primary" 
                                        data-tooltip-id="tooltiparriba"
                                        data-tooltip-content="Registrar Retorno Efectivo">
                                        <FaHeartbeat size={20} color="black" /> Efectivo
                                    </NavLink>
                                </div>
                                <div className="col-md-1">
                                    <NavLink to={`/retornos/imprimirformatocompleto/${retornoId}/${idCabezaFamilia}`} 
                                        data-tooltip-id="tooltiparriba"
                                        data-tooltip-content="Imprimir Formato(Completo)">
                                        <FaHeartbeat size={20} color="black" /> Completo
                                    </NavLink>
                                </div>
                                <div className="col-md-1">
                                    <NavLink to={`/retornos/imprimirformato/${retornoId}`} 
                                        className="btn btn-app bg-primary" 
                                        data-tooltip-id="tooltiparriba"
                                        data-tooltip-content="Imprimir Formato">
                                        <FaHeartbeat size={20} color="black" /> Imprimir
                                    </NavLink>
                                </div>
                                <div className="col-md-1">
                                    <NavLink to={`/retornos/imprimirformatovacio/${retornoId}`} 
                                        className="btn btn-app bg-primary" 
                                        data-tooltip-id="tooltiparriba"
                                        data-tooltip-content="Imprimir Formato vacio">
                                        <FaHeartbeat size={20} color="black" /> Imp. vacio
                                    </NavLink>
                                </div>
                                {rol === '2' && <div className="col-md-1">
                                    <button 
                                        type="button" 
                                        className="btn btn-app bg-primary" 
                                        data-tooltip-id="tooltiparriba"
                                        data-tooltip-content="Eliminar este retorno"
                                        onClick={() => EliminarRetorno(retornoId)}>
                                        <FaEraser size={20} color="black" /> Eliminar
                                    </button>
                                </div>}
                            </div>}
                        </div>
                        <form className="form-horizontal" onSubmit={handleSubmit(guardarRetorno)}>
                            <div className="card-body">
                                <input hidden {...register('usrId')}/><input hidden {...register('cabIdcabezafamilia')}/>
                                {retornoId>0 && <div className="row">
                                    <div className="col-md-6">
                                        <strong>RETORNO: </strong><span style={{fontWeight: 'bold',fontSize: '100%'}}>{retornoId}</span>
                                    </div>
                                </div>}
                                <div className="row">
                                    <div className="col-md-6">
                                        <strong>NOMBRE COMPLETO : </strong><span style={{fontWeight: 'bold',fontSize: '150%'}}>{CabezaFamiliaDatos.nombre}</span>
                                    </div>
                                    <div className="col-md-6">
                                        Documento de identidad : {CabezaFamiliaDatos.cab_idcabezafamilia}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-5">
                                        <div className="form-group" >
                                            <label htmlFor="cab_direccion">Direcci&oacute;n:</label>
                                            <div className="input-group my-colorpicker2">
                                                <input id="cab_direccion" {...register('cab_direccion', { required: true })}  className="form-control" placeholder="Dirección"/>
                                                <div className="input-group-append">
                                                    <button type="button" className="input-group-text" onClick={showModalDireccionPrincipal}>
                                                        <FaMap color="black" /> Generar dir. 
                                                    </button>
                                                </div>
                                            </div>
                                            {errors.cab_direccion && <p style={{color: 'red'}}>Digite direccion</p>}
                                            
                                        </div>
                                        
                                        <AddressGenerator show={showDireccionPrincipal} handleClose={hideModalDireccionPrincipal} setDireccion={setDireccionPrincipal}>
                                            <div>Este direccion</div>
                                        </AddressGenerator>
                                    </div>
                                    <div className="col-md-3">
                                        <label htmlFor="cab_barrio">Barrio o Vereda:</label>
                                        <select id="cab_barrio" {...register('cab_barrio', { required: true })} className='form-control' >
                                            <option value="">Seleccionar</option>
                                            {barrios.map((option) => (
                                            <option key={option.id} value={option.id}>
                                                {option.barBarrio}
                                            </option>
                                            ))}
                                        </select>
                                        {errors.cab_barrio && <p style={{color: 'red'}}>Seleccione barrio</p>}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="cab_telefono1">Tel&eacute;fono:</label>
                                            <input id="cab_telefono1" {...register('cab_telefono1', { required: true })}  className="form-control" placeholder="Telefono 1"/>
                                            {errors.cab_telefono1 && <p style={{color: 'red'}}>Digite telefono</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="cab_telefono2">Otro Tel&eacute;fono:</label>
                                            <input id="cab_telefono2" {...register('cab_telefono2')}  className="form-control" placeholder="Telefono 2"/>
                                            {errors.cab_telefono2 && <p style={{color: 'red'}}>Digite otro telefono</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="cab_celular">Celular:</label>
                                            <input id="cab_celular" {...register('cab_celular')}  className="form-control" placeholder="Celular"/>
                                            {errors.cab_celular && <p style={{color: 'red'}}>Digite celular</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className='col-md-3'>
                                        <div className="form-group">
                                            <label htmlFor="fechaEntrevista">Fecha Realizaci&oacute;n Entrevista:</label>
                                            <Controller
                                                id="fechaEntrevista"
                                                control={control}
                                                name="fechaEntrevista"
                                                render={({ field }) => (
                                                    <DatePicker
                                                    placeholderText="fecha"
                                                    onChange={(date) => field.onChange(date)}
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    dropdownMode="select"
                                                    selected={field.value}
                                                    customInput={<CustomInput />}
                                                    locale="es"
                                                    dateFormat="yyyy-MM-dd"
                                                    />
                                                )}
                                            />
                                            {errors.fechaEntrevista && <p style={{color: 'red'}}>Digite fecha entrevista</p>}
                                        </div>
                                    </div>
                                    <div className='col-md-3'>
                                        <div className="form-group">
                                            <label htmlFor="fechaVisitaDomiciliaria">Fecha Realizaci&oacute;n Visita Domiciliaria:</label>
                                            <Controller
                                                id="fechaVisitaDomiciliaria"
                                                control={control}
                                                name="fechaVisitaDomiciliaria"
                                                render={({ field }) => (
                                                    <DatePicker
                                                    placeholderText="fecha"
                                                    onChange={(date) => field.onChange(date)}
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    dropdownMode="select"
                                                    selected={field.value}
                                                    customInput={<CustomInput />}
                                                    locale="es"
                                                    dateFormat="yyyy-MM-dd"
                                                    />
                                                )}
                                            />
                                            {errors.fechaVisitaDomiciliaria && <p style={{color: 'red'}}>Digite fecha visita domiciliaria</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <h3>1. VALORACION SITUACION INICIAL ENCONTRADA</h3>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className='row'>
                                            <div className="col-md-12">
                                                <label htmlFor="valoracionSituacionInicial">Descripci&oacute;n</label>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className="col-md-12">
                                            <textarea rows={3} style={{ width: '100%' }}
                                                {...register('valoracionSituacionInicial', { required: true })}
                                                placeholder="Valoración inicial"
                                            />
                                            {errors.valoracionSituacionInicial && <p style={{color: 'red'}}>Favor digite la valoracion</p>}
                                            </div>
                                        </div>
                                    
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <h3>2. DATOS DEL DESPLAZAMIENTO:</h3>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group" >
                                            <label htmlFor="municipioDesplazamiento">MUNICIPIO EXPULSOR:</label>
                                            <select id="municipioDesplazamiento" {...register('municipioDesplazamiento', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {municipiosdto.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.dep_departamento} - {item.mun_municipio}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.municipioDesplazamiento && <p style={{color: 'red'}}>Seleccione municipio</p>}
                                        </div>
                                    </div>
                                    <div className='col-md-3'>
                                        <div className="form-group">
                                            <label htmlFor="fechaDesplazamiento">Fecha de desplazamiento:</label>
                                            <Controller
                                                id="fechaDesplazamiento"
                                                control={control}
                                                name="fechaDesplazamiento"
                                                render={({ field }) => (
                                                    <DatePicker
                                                    placeholderText="fecha"
                                                    onChange={(date) => field.onChange(date)}
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    dropdownMode="select"
                                                    selected={field.value}
                                                    customInput={<CustomInput />}
                                                    locale="es"
                                                    dateFormat="yyyy-MM-dd"
                                                    maxDate={new Date()}
                                                    />
                                                )}
                                            />
                                            {errors.fechaDesplazamiento && <p style={{color: 'red'}}>Digite fecha registro victima</p>}
                                        </div>
                                    </div>
                                    
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        No. DE  PERSONAS: <input disabled {...register('nropersonas')}/>
                                    </div>
                                    <div className="col-md-6">
                                        TIEMPO QUE LLEVA EN  LA CIUDAD: <input disabled {...register('tiempociudad')}/>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <h3>3. DATOS FAMILIARES DEL NUCLEO FAMILIAR SEG&uacute;N DECLARACION</h3>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="card-body table-responsive p-0">
                                            <h5>Integrantes de la familia</h5>
                                            <table className="table table-bordered table-hover">
                                                <thead>
                                                    <tr>
                                                        <th>Retorna/Editar Datos</th>
                                                        <th>Nombres completos</th>
                                                        <th>Identificación</th>
                                                        <th>F.Nacimiento</th>
                                                        <th>Parentesco</th>
                                                        <th>Etnia</th>
                                                        <th>Edad</th>
                                                        <th>Ocupación actual</th>
                                                        <th>Perfil ocupacional</th>
                                                        <th>Estudia actualmente</th>
                                                        <th>Discapacidad</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {personasGrupoFamiliar.length === 0 ? (
                                                        <tr>
                                                            <td colSpan="11" className="text-center">
                                                                No hay datos para mostrar
                                                            </td>
                                                        </tr>
                                                    ) : (
                                                        personasGrupoFamiliar.map((row, idx) => (
                                                            <tr key={row.per_idpersona || idx}>
                                                                <td>
                                                                    <div className="form-group">
                                                                        <input
                                                                            type="checkbox"
                                                                            checked={row.seleccion || false}
                                                                            onChange={e => {
                                                                                const updatedPersonas = personasGrupoFamiliar.map(persona =>
                                                                                    persona.per_idpersona === row.per_idpersona
                                                                                        ? { ...persona, seleccion: e.target.checked }
                                                                                        : persona
                                                                                );
                                                                                setPersonasGrupoFamiliar(updatedPersonas);
                                                                            }}
                                                                        />
                                                                    </div>
                                                                </td>
                                                                <td>{`${row.per_nombre1} ${row.per_nombre2 || ''} ${row.per_apellido1} ${row.per_apellido2 || ''}`.trim()}</td>
                                                                <td>{row.per_idpersona}</td>
                                                                <td>{row.per_fechanac}</td>
                                                                <td>{row.par_parentesco}</td>
                                                                <td>{row.min_minoria}</td>
                                                                <td>{row.per_edad}</td>
                                                                <td>{row.ocupacion}</td>
                                                                <td>{row.ofi_oficio}</td>
                                                                <td>{row.tipo_estudio}</td>
                                                                <td>{row.dis_discapacidad}</td>
                                                            </tr>
                                                        ))
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        3.1. Relacione los motivos planteados por el grupo familiar, para tomar la decisi&oacute;n de Retornar & Reubicarse. (Opcion multiple)
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group" >
                                            <Select
                                                id="motivoId"
                                                value={motivosSeleccionados}
                                                isMulti
                                                name="motivoId"
                                                options={tiposmotivo}
                                                onChange={ActualizarMotivos}
                                                className="basic-multi-select"
                                                classNamePrefix="Seleccione"
                                            />
                                            {errors.tipoExplotacion && <p style={{color: 'red'}}>Seleccione motivos</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                    3.2. Razones por las cuales no se genero voluntariedad de algunos miembros del n&uacute;cleo familiar, (Aplica para aquellas familiares donde la decisi&oacute;n no la asumen todos/as los miembros del n&uacute;cleo familiar).  (Opcion multiple)
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group" >
                                            <Select
                                                id="voluntariedadId"
                                                value={tiposVoluntariedadSeleccionados}
                                                isMulti
                                                name="voluntariedadId"
                                                options={tiposvoluntariedad}
                                                onChange={ActualizarTiposVoluntariedad}
                                                className="basic-multi-select"
                                                classNamePrefix="Seleccione"
                                            />
                                            {errors.tiposvoluntariedad && <p style={{color: 'red'}}>Seleccione motivos</p>}
                                        </div>                                        
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <h3>4. CONDICIONES ACTUALES PARA EL RETORNO O REUBICACION (FASE EXPLORATORIA)</h3>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        4.1  Indique si su petici&oacute;n es para Retorno o Reubicaci&oacute;n.
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group" >
                                            <select {...register('tipoApoyoId', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {tiposapoyo.map((option) => (
                                                <option key={option.id} value={option.id}>
                                                    {option.tipTipoapoyo}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.tipoApoyoId && <p style={{color: 'red'}}>Seleccione tipo apoyo</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group" >
                                            <label htmlFor="departamentoPeticion">A. Departamento</label>
                                            <select id="departamentoPeticion" {...register('departamentoPeticion', { required: true })} onChange={ActualizarMunicipios} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {departamentos.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.depDepartamento}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.departamentoPeticion && <p style={{color: 'red'}}>Seleccione departamento</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group" >
                                            <label htmlFor="municipioPeticion">C. Municipio</label>
                                            <select id="municipioPeticion" {...register('municipioPeticion', { required: true })} onChange={ActualizarBarrios} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {municipios.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.munMunicipio}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.municipioPeticion && <p style={{color: 'red'}}>Seleccione municipio</p>}
                                        </div>
                                    </div>
                                </div> 
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group" >
                                            <label htmlFor="direccionPeticion">B. Direcci&oacute;n:</label>
                                            <div className="input-group my-colorpicker2">
                                                <input id="direccionPeticion" {...register('direccionPeticion', { required: true })}  className="form-control" placeholder="Dirección"/>
                                                <div className="input-group-append">
                                                    <button type="button" className="input-group-text" onClick={showModalDireccionPeticion}>
                                                        <FaMap color="black" /> Generar dir.
                                                    </button>
                                                </div>
                                            </div>
                                            {errors.direccionPeticion && <p style={{color: 'red'}}>Digite direccion</p>}
                                        </div>
                                        <AddressGenerator show={showDireccionPeticion} setDireccion={setDireccionPeticion} handleClose={hideModalDireccionPeticion}>
                                            <div>Este direccion</div>
                                        </AddressGenerator>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group" >
                                            <label htmlFor="telefonoPeticion">D. Tel&eacute;fono:</label>
                                            <input id="telefonoPeticion" {...register('telefonoPeticion', { required: true })}  className="form-control" placeholder="Telefono"/>
                                            {errors.telefonoPeticion && <p style={{color: 'red'}}>Digite telefono</p>}
                                        </div>
                                    </div>
                                </div> 
                                <div className="row">
                                    <div hidden className="col-md-6">
                                        <div className="form-group" >
                                            <label htmlFor="corregimientoPeticion">E. Corregimiento</label>
                                            <select id="corregimientoPeticion" {...register('corregimientoPeticion' )} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {barriosPeticion.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.barBarrio}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.corregimientoPeticion && <p style={{color: 'red'}}>Seleccione corregimiento</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group" >
                                            <label htmlFor="tipoentornoPeticion">F. Entorno</label>
                                            <select id="tipoentornoPeticion" {...register('tipoentornoPeticion', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {tiposentorno.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.tipTipoentorno}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.tipoentornoPeticion && <p style={{color: 'red'}}>Seleccione tipo entorno</p>}
                                        </div>
                                    </div>
                                </div> 
                                <div className="row">
                                    <div className="col-md-6">
                                    <div className="form-group" >
                                            <label htmlFor="veredabarrioPeticion">G. Vereda o Barrio </label>
                                            <input {...register('veredabarrioPeticion')} className="form-control" placeholder="barrio o vereda"/>
                                            {errors.veredabarrioPeticion && <p style={{color: 'red'}}>Digite vereda o barrio</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group" >
                                            <label htmlFor="nombrefincaPeticion">H. Nombre de la Finca: </label>
                                            <input id="nombrefincaPeticion" {...register('nombrefincaPeticion')}  className="form-control" placeholder="Nombre"/>
                                            {errors.nombrefincaPeticion && <p style={{color: 'red'}}>Digite nombre finca</p>}
                                        </div>
                                    </div>
                                </div> 
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className='row'>
                                            <div className="col-md-12">
                                                <label htmlFor="referenciasPeticion">I. Referencias del lugar de llegada:</label>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className="col-md-12">
                                            <textarea rows={3} style={{ width: '100%' }}
                                                {...register('referenciasPeticion')}
                                                placeholder="Referencias"
                                            />
                                            {errors.referenciasPeticion && <p style={{color: 'red'}}>Favor digite referencias de la petici&oacute;n</p>}
                                            </div>
                                        </div>
                                    
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-8">
                                        <div className="form-group" >
                                            <label htmlFor="viviendaIntegrante">4.2. La vivienda en el lugar del retorno o la reubicaci&oacute;n  es de alg&uacute;n integrante de la familia incluida</label>
                                            <select id="viviendaIntegrante" {...register('viviendaIntegrante', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.viviendaIntegrante && <p style={{color: 'red'}}>Seleccione campo</p>}
                                        </div>
                                    </div>
                                </div>
                                {viviendaIntegrante === 'SI' && <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="propietarioViviendaNucleo">4.2.1 Miembro de n&uacute;cleo</label>
                                            <select id="propietarioViviendaNucleo" {...register('propietarioViviendaNucleo', { validate: value => {
                                                        if (viviendaIntegrante === 'SI' && !value) {
                                                        return 'Seleccione integrante';
                                                        }
                                                        return true;
                                                    }
                                                    })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {personasGrupoFamiliar.map((item) => (
                                                <option key={item.per_idpersona} value={item.per_idpersona}>
                                                    {item.per_nombre1} {item.per_nombre2} {item.per_apellido1} {item.per_apellido2}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.propietarioViviendaNucleo && <p style={{color: 'red'}}>Seleccione integrante</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="propietarioVivienda">4.2.2 Tipo de propiedad</label>
                                            <select id="propietarioVivienda" {...register('propietarioVivienda', { validate: value => {
                                                        if (viviendaIntegrante === 'SI' && !value) {
                                                        return 'Seleccione tipo propiedad';
                                                        }
                                                        return true;
                                                    }
                                                    })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {tiposPropietario.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.tipTipopropietario}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.propietarioVivienda && <p style={{color: 'red'}}>Seleccione tipo propiedad</p>}
                                        </div>
                                    </div>
                                </div>}
                                {viviendaIntegrante === 'SI' && <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="documentacionVivienda">4.2.3.  Tiene documentaci&oacute;n de esa vivienda o tierras</label>
                                            <select id="documentacionVivienda" {...register('documentacionVivienda', { validate: value => {
                                                        if (viviendaIntegrante === 'SI' && !value) {
                                                        return 'Seleccione tiene documentacion';
                                                        }
                                                        return true;
                                                    }
                                                    })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.documentacionVivienda && <p style={{color: 'red'}}>Seleccione campo</p>}
                                        </div>
                                    </div>
                                </div>}
                                {documentacionVivienda === 'SI' && <div className="row">                                    
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            <label htmlFor="protegioBien">A. Protegi&oacute; el bien abandonado</label>
                                            <select id="protegioBien" {...register('protegioBien', { validate: value => {
                                                        if (documentacionVivienda === 'SI' && !value) {
                                                        return 'Seleccione protegio bien';
                                                        }
                                                        return true;
                                                    }
                                                    })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.protegioBien && <p style={{color: 'red'}}>Seleccione campo</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            <label htmlFor="tipoBien">B. ¿Qu&eacute; tipo de bien es?</label>
                                            <select id="tipoBien" {...register('tipoBien', { validate: value => {
                                                        if (documentacionVivienda === 'SI' && !value) {
                                                        return 'Seleccione tipo bien';
                                                        }
                                                        return true;
                                                    }
                                                    })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {retornoTipoBien.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.tipTipobien}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.tipoBien && <p style={{color: 'red'}}>Seleccione campo</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            <label htmlFor="resolucionProteccion">C. Tiene Resolucion de proteccion</label>
                                            <select id="resolucionProteccion" {...register('resolucionProteccion', { validate: value => {
                                                        if (documentacionVivienda === 'SI' && !value) {
                                                        return 'Seleccione tipo propiedad';
                                                        }
                                                        return true;
                                                    }
                                                    })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.resolucionProteccion && <p style={{color: 'red'}}>Seleccione campo</p>}
                                        </div>
                                    </div>
                                </div>}
                                <div className="row">
                                    <div className="col-md-12">
                                        <h5>4.3  Estado actual de la vivienda donde se retorna o se reubica :</h5>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="form-group" >
                                            <label htmlFor="estadoTecho">Techo:</label>
                                            <select id="estadoTecho" {...register('estadoTecho', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {estadosBien.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.retEstadobien}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.estadoTecho && <p style={{color: 'red'}}>Seleccione estado</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="form-group" >
                                            <label htmlFor="estadoPisos">Pisos:</label>
                                            <select id="estadoPisos" {...register('estadoPisos', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {estadosBien.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.retEstadobien}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.estadoPisos && <p style={{color: 'red'}}>Seleccione estado</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="form-group" >
                                            <label htmlFor="estadoBanos">Baños:</label>
                                            <select id="estadoBanos" {...register('estadoBanos', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {estadosBien.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.retEstadobien}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.estadoBanos && <p style={{color: 'red'}}>Seleccione estado</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="form-group" >
                                            <label htmlFor="estadoParedes">Paredes:</label>
                                            <select id="estadoParedes" {...register('estadoParedes', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {estadosBien.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.retEstadobien}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.estadoParedes && <p style={{color: 'red'}}>Seleccione estado</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-2">
                                        <div className="form-group" >
                                            <label htmlFor="estadoCocina">Cocina:</label>
                                            <select {...register('estadoCocina', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {estadosBien.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.retEstadobien}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.estadoCocina && <p style={{color: 'red'}}>Seleccione estado</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group" >
                                            <label htmlFor="servicioAlcantarillado">LA SOLUCION HABITACIONAL CUENTA CON SERVICIO DE ALCANTARILLADO:</label>
                                            <select id="servicioAlcantarillado" {...register('servicioAlcantarillado', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.servicioAlcantarillado && <p style={{color: 'red'}}>Seleccione campo</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-6">
                                        <div className="form-group" >
                                            <label htmlFor="servicioPozoSeptico">LA SOLUCION  HABITACIONAL CUENTA CON POZO SEPTICO:</label>
                                            <select id="servicioPozoSeptico" {...register('servicioPozoSeptico', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.servicioPozoSeptico && <p style={{color: 'red'}}>Seleccione campo</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group" >
                                            <label htmlFor="servicioAcueducto">LA SOLUCION CUENTA CON SERVICIO DE ACUEDUCTO:</label>
                                            <select id="servicioAcueducto" {...register('servicioAcueducto', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.servicioAcueducto && <p style={{color: 'red'}}>Seleccione campo</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-5">
                                        <div className="form-group" >
                                            <label htmlFor="servicioEnergia">LA SOLUCION HABITACIONAL CUENTA CON SERVICIO DE ENERGIA :</label>
                                            <select {...register('servicioEnergia', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.servicioEnergia && <p style={{color: 'red'}}>Seleccione campo</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-7">
                                        <div className="form-group" >
                                            <label htmlFor="otraFuenteAgua">LA SOLUCION CUENTA CON OTRA FUENTE DE ABASTECIMIENTO DE AGUA POTABLE, CUAL?:</label>
                                            <select id="otraFuenteAgua" {...register('otraFuenteAgua', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.otraFuenteAgua && <p style={{color: 'red'}}>Seleccione estado</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <h3>5. ESTADO ACTUAL DE ATENCI&oacute;N EN SALUD :</h3>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            <label htmlFor="afiliacionSalud">A. Afiliacion Salud:</label>
                                            <select {...register('salud', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {ordenSalud.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.salDescripcion}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.salud && <p style={{color: 'red'}}>Seleccione campo</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-7">
                                        <div className="form-group" >
                                            <label htmlFor="educacion">Educaci&oacute;n:</label>
                                            <select {...register('educacion', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.educacion && <p style={{color: 'red'}}>Seleccione estado</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                <div className="col-md-5">
                                        <div className="form-group" >
                                            <label htmlFor="miembrosAtencionPsicosocial">B. ¿Los miembros del hogar requieren atenci&oacute;n Psicosocial? (Opcion multiple)</label>
                                            <select {...register('miembrosAtencionPsicosocial', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.miembrosAtencionPsicosocial && <p style={{color: 'red'}}>Seleccione estado</p>}
                                        </div>
                                    </div>
                                    {miembrosAtencionPsicosocial === 'SI' && <div className="col-md-7">
                                        <div className="form-group" >
                                            <label htmlFor="quienesPsicosocial">¿Qui&eacute;nes?</label>
                                            <Select
                                                value={quienesPsicosocial}
                                                isMulti
                                                name="QuienesPsicosocial"
                                                options={Personas}
                                                onChange={ActualizarQuienesPsicosocial}
                                                className="basic-multi-select"
                                                classNamePrefix="Seleccione"
                                            />
                                            {errors.QuienesPsicosocial && <p style={{color: 'red'}}>Seleccione campos</p>}
                                            
                                        </div>
                                    </div>}
                                </div>
                                <div hidden className="row">
                                    <div className="col-md-12">
                                        <h3>6. CONVOCATORIAS DE VIVIENDA</h3>
                                    </div>
                                </div>
                                <div hidden className="row">
                                    <div className="col-md-6">
                                        <div className="form-group" >
                                            <label htmlFor="convocatoriaVivienda">¿SE HA POSTULADO A LAS CONVOCATORIAS DE VIVIENDA?</label>
                                            <select id="convocatoriaVivienda" {...register('convocatoriaVivienda')} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.convocatoriaVivienda && <p style={{color: 'red'}}>Seleccione campo</p>}
                                        </div>
                                    </div>
                                    {convocatoriaVivienda === 'SI' && <div className="col-md-6">
                                        <div className="form-group" >
                                            <label htmlFor="convocatoriaCual">¿C&uacute;al?</label>
                                            <select id="convocatoriaCual" {...register('convocatoriaCual', { validate: value => {
                                                        if (convocatoriaVivienda === 'SI' && !value) {
                                                        return 'Seleccione convocatoria';
                                                        }
                                                        return true;
                                                    }
                                                    })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {tiposConvocatoria.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.tipTipoconvocatoria}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.convocatoriaCual && <p style={{color: 'red'}}>Seleccione convocatoria</p>}
                                        </div>
                                    </div>}
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <h3>6. REDES FAMILIARES Y/O SOCIALES EN El LUGAR A RETORNAR O REUBICAR (ANALISIS SITUACIONAL)</h3>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-2">
                                        <div className="form-group" >
                                            <label htmlFor="redTipo">Red</label>
                                            <select id="redTipo" {...register('redTipo')} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                {tiposred.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.tipTipored}
                                                </option>
                                                ))}
                                            </select>
                                            {errors.redTipo && <p style={{color: 'red'}}>Seleccione campo</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            <label htmlFor="redParentesco">Parentesco:</label>
                                            <input id="redParentesco" {...register('redParentesco')}  className="form-control" placeholder="Parentesco"/>
                                            {errors.redParentesco && <p style={{color: 'red'}}>Digite parentesco</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            <label htmlFor="redNombre">Nombres Completos:</label>
                                            <input id="redNombre" {...register('redNombre')}  className="form-control" placeholder="Nombre completo"/>
                                            {errors.redNombre && <p style={{color: 'red'}}>Digite nombre completo</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            <label htmlFor="redTelefonos">Tel&eacute;fonos-Celular:</label>
                                            <input id="redTelefonos" {...register('redTelefonos')}  className="form-control" placeholder="Telefono - celular"/>
                                            {errors.redTelefonos && <p style={{color: 'red'}}>Digite telefono o celular</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-7">
                                        <div className="form-group" >
                                            <label htmlFor="redDireccion">Direcci&oacute;n:</label>
                                            <div className="input-group my-colorpicker2">
                                                <input id="redDireccion" {...register('redDireccion')}  className="form-control" placeholder="Dirección"/>
                                                <div className="input-group-append">
                                                    <button type="button" className="input-group-text" onClick={showModalDireccionRed}>
                                                        <FaMap size={20} color="black" /> Generar dir.
                                                    </button>
                                                <span className="input-group-text">
                                                    
                                                </span>
                                                </div>
                                            </div>
                                            {errors.redDireccion && <p style={{color: 'red'}}>Digite direccion</p>}
                                            
                                        </div>
                                        <AddressGenerator show={showDireccionRed} setDireccion={setDireccionRed} handleClose={hideModalDireccionRed}>
                                            <div>Este direccion</div>
                                        </AddressGenerator>
                                        
                                    </div>
                                    <div className="col-md-3">
                                        <label htmlFor="redMunicipio">Municipio:</label>
                                        <select id="redMunicipio" {...register('redMunicipio')} className='form-control' >
                                            <option value="">Seleccionar</option>
                                            {municipiosdto.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                     {item.mun_municipio} - {item.dep_departamento}
                                                </option>
                                                ))}
                                        </select>
                                        {errors.redMunicipio && <p style={{color: 'red'}}>Seleccione municipio</p>}
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-2">
                                        <button type="button" className="btn btn-primary" onClick={AgregarRedSocial}>Agregar</button>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="card-body table-responsive p-0">
                                            <h5>Lista red social</h5>
                                            <table className="table table-bordered table-hover">
                                                <thead>
                                                    <tr>
                                                        <th>Acciones</th>
                                                        <th>Red</th>
                                                        <th>Parentesco</th>
                                                        <th>Nombre</th>
                                                        <th>Telefono - celular</th>
                                                        <th>Direccion</th>
                                                        <th>Municipio</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {getValues('RedSocialSeleccionado') && getValues('RedSocialSeleccionado').length === 0 ? (
                                                        <tr>
                                                            <td colSpan="7" className="text-center">
                                                                No hay datos para mostrar
                                                            </td>
                                                        </tr>
                                                    ) : (
                                                        getValues('RedSocialSeleccionado') && getValues('RedSocialSeleccionado').map((row, idx) => (
                                                            <tr key={idx}>
                                                                <td>
                                                                    <BotonBorrar Borrar={BorrarRedSocial} row={row} />
                                                                </td>
                                                                <td>{row.redTipo}</td>
                                                                <td>{row.redParentesco}</td>
                                                                <td>{row.redNombre}</td>
                                                                <td>{row.redTelefonos}</td>
                                                                <td>{row.redDireccion}</td>
                                                                <td>{row.municipio}</td>
                                                            </tr>
                                                        ))
                                                    )}
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className='row'>
                                            <div className="col-md-12">
                                                <label htmlFor="redDescripcionValoracion">Describir la percepci&oacute;n de la valoraci&oacute;n que hace la familia de su red familiar y/o laboral</label>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className="col-md-12">
                                            <textarea rows={3} style={{ width: '100%' }}
                                                {...register('redDescripcionValoracion', { required: true })}
                                                placeholder="Descripción"
                                            />
                                            {errors.redDescripcionValoracion && <p style={{color: 'red'}}>Favor digite la descripción</p>}
                                            </div>
                                        </div>
                                    
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <h3>7. VALORACIÓN Y ANALISIS SITUACIONAL DEL LUGAR DE LLEGADA</h3>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className='row'>
                                            <div className="col-md-12">
                                                <label htmlFor="estadoActualSeguridad">8.1 ¿Conoce el estado actual de seguridad en el lugar retorno o reubicaci&oacute;n?</label>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className="col-md-12">
                                            <textarea rows={3} style={{ width: '100%' }}
                                                {...register('estadoActualSeguridad', { required: true })}
                                                placeholder="Estado actual seguridad"
                                            />
                                            {errors.estadoActualSeguridad && <p style={{color: 'red'}}>Favor digite el estado actual</p>}
                                            </div>
                                        </div>
                                    
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className='row'>
                                            <div className="col-md-12">
                                                <label htmlFor="observacionesFinales">OBSERVACIONES FINALES</label>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className="col-md-12">
                                            <textarea rows={3} style={{ width: '100%' }}
                                                {...register('observacionesFinales', { required: true })}
                                                placeholder="Observaciones"
                                            />
                                            {errors.observacionesFinales && <p style={{color: 'red'}}>Favor digite observaciones</p>}
                                            </div>
                                        </div>
                                    
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <h3>VERIFICACI&oacute;N REDES SOCIALES Y FAMILIARES: actividad que se desarrollara posterior a la visita domiciliaria con el objetivo de ampliar informaci&oacute;n social y familiar antes de la citaci&oacute;n a actividad grupal familiar, actividad que ser&aacute; desarrollada por Profesional Psicosocial de la Gerencia.</h3>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className='col-md-3'>
                                        <div className="form-group">
                                            <label htmlFor="redesFecha">Fecha verificaci&oacute;n:</label>
                                            <Controller
                                                id="redesFecha"
                                                control={control}
                                                name="redesFecha"
                                                render={({ field }) => (
                                                    <DatePicker
                                                    placeholderText="fecha"
                                                    onChange={(date) => field.onChange(date)}
                                                    showMonthDropdown
                                                    showYearDropdown
                                                    dropdownMode="select"
                                                    selected={field.value}
                                                    customInput={<CustomInput />}
                                                    locale="es"
                                                    dateFormat="yyyy-MM-dd"
                                                    />
                                                )}
                                            />
                                            {errors.redFecha && <p style={{color: 'red'}}>Digite fecha validacion redes sociales</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-3">
                                        <div className="form-group" >
                                            <label htmlFor="redesNombreContacto">Nombre de quien se contacto</label>
                                            <input id="redesNombreContacto" {...register('redesNombreContacto')}  className="form-control" placeholder="Nombre contacto"/>
                                            {errors.redesNombreContacto && <p style={{color: 'red'}}>Digite nombre contacto</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className='row'>
                                            <div className="col-md-12">
                                                <label htmlFor="redesResultado">Resultado</label>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className="col-md-12">
                                            <textarea rows={3} style={{ width: '100%' }}
                                                {...register('redesResultado')}
                                                placeholder="Resultado"
                                            />
                                            {errors.redesResultado && <p style={{color: 'red'}}>Favor digite resultado</p>}
                                            </div>
                                        </div>
                                    
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12" style={{textAlign: 'center'}}>
                                        <h3>INFORMACION POSTERIOR A LA VISITA</h3>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="redesVoluntariedad">Voluntariedad:</label>
                                            <select id="redesVoluntariedad" {...register('redesVoluntariedad', { required: true })} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.redesVoluntariedad && <p style={{color: 'red'}}>Seleccione campo</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <label htmlFor="redesConceptoSeguridad">Seguridad: Concepto de seguridad</label>
                                        <select {...register('redesConceptoSeguridad', { required: true })} className='form-control' >
                                            <option value="">Seleccionar</option>
                                            {conceptosSeguridad.map((item) => (
                                                <option key={item.id} value={item.id}>
                                                    {item.conConceptoseguridad} 
                                                </option>
                                                ))}
                                        </select>
                                        {errors.redesConceptoSeguridad && <p style={{color: 'red'}}>Seleccione concepto</p>}
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="redesEntidadConcepto">Entidad que emite el concepto:</label>
                                            <input id="redesEntidadConcepto" {...register('redesEntidadConcepto', { required: true })}  className="form-control" placeholder="Entidad concepto"/>
                                            {errors.redesEntidadConcepto && <p style={{color: 'red'}}>Digite la entidad</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <h3>Psicosocial</h3>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="form-group" >
                                            <label htmlFor="redesPlanVida">Se construyo plan de vida para el proceso de Retorno & Reubicaci&oacute;n?</label>
                                            <select id="redesPlanVida" {...register('redesPlanVida')} className='form-control' >
                                                <option value="">Seleccionar</option>
                                                <option value="SI">SI</option>
                                                <option value="NO">NO</option>
                                            </select>
                                            {errors.redesPlanVida && <p style={{color: 'red'}}>Seleccione campo</p>}
                                        </div>
                                    </div>
                                </div>
                                {redesPlanVida === 'SI' && <div className="row">
                                    <div className="col-md-12">
                                        <div className='row'>
                                            <div className="col-md-12">
                                                <label htmlFor="redesDescripcionPlanVida">Describir el proyecto de vida o plan de vida que tiene la familia o las personas que desean retornar o se reubicarsen</label>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className="col-md-12">
                                            <textarea rows={3} style={{ width: '100%' }}
                                                {...register('redesDescripcionPlanVida', { validate: value => {
                                                    if (redesPlanVida === 'SI' && !value) {
                                                    return 'Realice descripcion';
                                                    }
                                                    return true;
                                                }
                                                })}
                                                placeholder="Descripción plan de vida"
                                            />
                                            {errors.redesDescripcionPlanVida && <p style={{color: 'red'}}>Favor digite descripci&oacute;n</p>}
                                            </div>
                                        </div>
                                    
                                    </div>
                                </div>}
                                <div className="row">
                                    <div className="col-md-12">
                                        <h3>Socio Econ&oacute;mico</h3>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-7">
                                        <div className="form-group" >
                                            <label htmlFor="tipoExplotacion">Se construyo plan de vida para el proceso de Retorno & Reubicaci&oacute;n?</label>
                                            <Select
                                                id="tipoExplotacion"
                                                value={tiposExplotacionSeleccionados}
                                                isMulti
                                                name="tipoExplotacion"
                                                options={tiposExplotacion}
                                                onChange={ActualizarTiposExplotacion}
                                                className="basic-multi-select"
                                                classNamePrefix="Seleccione"
                                            />
                                            {errors.tipoExplotacion && <p style={{color: 'red'}}>Seleccione campos</p>}
                                        </div>
                                    </div>
                                    <div hidden className="col-md-5">
                                        <div className="form-group" >
                                            <label htmlFor="tipoEspecie">Especies que le gustar&iacute;a trabajar en su predio</label>
                                            <Select
                                                id="tipoEspecie"
                                                value={tiposEspeciesSeleccionados}
                                                isMulti
                                                name="tipoEspecie"
                                                options={tiposEspecies}
                                                onChange={ActualizarTiposEspecies}
                                                className="basic-multi-select"
                                                classNamePrefix="Seleccione"
                                            />
                                            {errors.tipoEspecie && <p style={{color: 'red'}}>Seleccione campos</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <h3>Caracter&iacute;sticas F&iacute;sicas</h3>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="areaHuerta">&aacute;rea que dispone para la huerta casera</label>
                                            <input id="areaHuerta" {...register('areaHuerta')}  className="form-control" placeholder="Área huerta"/>
                                            {errors.areaHuerta && <p style={{color: 'red'}}>Digite el &aacute;rea</p>}
                                        </div>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className='row'>
                                            <div className="col-md-12">
                                                <label htmlFor="redesDescripcionInsumos">Describir los insumos o materiales que requiere el acampamiento con el plan productivo diferencial</label>
                                            </div>
                                        </div>
                                        <div className='row'>
                                            <div className="col-md-12">
                                            <textarea rows={3} style={{ width: '100%' }}
                                                {...register('redesDescripcionInsumos', { required: true })}
                                                placeholder="Descripción insumos"
                                            />
                                            {errors.redesDescripcionInsumos && <p style={{color: 'red'}}>Favor digite descripci&oacute;n</p>}
                                            </div>
                                        </div>
                                    
                                    </div>
                                </div>
                                <div hidden className="row">
                                    <div className="col-md-12">
                                        <h3>Valores aproximados a entregar</h3>
                                    </div>
                                </div>
                                <div hidden className="row">
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="redesTransportePersonasNro">Transporte de Personas  No de personas</label>
                                            <input id="redesTransportePersonasNro" {...register('redesTransportePersonasNro')}  className="form-control" placeholder="Nro"/>
                                            {errors.redesTransportePersonasNro && <p style={{color: 'red'}}>Digite el numero</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="redesTransportePersonasCosto">Costos  aproximados</label>
                                            <input id="redesTransportePersonasCosto" {...register('redesTransportePersonasCosto')}  className="form-control" placeholder="Costo"/>
                                            {errors.redesTransportePersonasCosto && <p style={{color: 'red'}}>Digite el costo</p>}
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="form-group" >
                                            <label htmlFor="redesAcarreoCosto">Acarreo de Enseres: Costos aproximados</label>
                                            <input id="redesAcarreoCosto" {...register('redesAcarreoCosto')}  className="form-control" placeholder="Costo"/>
                                            {errors.redesAcarreoCosto && <p style={{color: 'red'}}>Digite el costo</p>}
                                        </div>
                                    </div>
                                </div>
                                <div hidden className="row">
                                    <div className="col-md-12" style={{textAlign: 'center'}}>
                                        <h5>Describir objetos por llevar (Digitar los campos cuando aplique)</h5>
                                    </div>
                                </div>
                                <div hidden className="row">
                                    {tiposobjeto.map(objeto => 
                                        <div key={objeto.id} className="col-md-3" >
                                            <div className="form-group">
                                                {objeto.tipoObjeto}
                                                <input key={objeto.id} {...register(`retornoobjeto.${objeto.id}`)} className="form-control" placeholder="Cantidad"/>
                                            </div>
                                        </div>
                                    )}
                                </div>
                                
                            </div>
                            <div className="card-footer">
                                <button type="submit" className="btn btn-primary">Guardar</button>
                            </div>
                        </form>
                        </div>
                        {/* /.card */}

                    </div>
                    {/*/.col (left) */}

                    </div>
                    {/* /.row */}
                </div>{/* /.container-fluid */}
                <SweetAlert2 {...swalProps} 
                didClose={() => {
                    setSwalProps({})
                }}/>
                <Tooltip id="tooltiparriba" place="right"/>
            </section>
        </div>
    );
    
}